import type { ImageDataLike } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';


function useExpertImageQuery(): ImageDataLike | null {
  const data = useStaticQuery(graphql`
    query ExpertImage {
      file(sourceInstanceName: { eq: "images" }, relativePath: { eq: "author.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 200)
        }
      }
    }
  `);

  return data.file;
}

export default useExpertImageQuery;
